import PageLayout, { Section } from "./PageLayout";

export default function Privacy() {
  return (
    <PageLayout
      eyebrow="Legal"
      title="Privacy Policy"
      subtitle="Last updated: February 8, 2026 — your data, your rules."
    >
      <Section title="1. What we collect">
        <p><strong className="text-white">Account info</strong>: name, email, hashed password, country.</p>
        <p><strong className="text-white">Billing</strong>: PayPal order IDs and last-4 of payment method (we never store full card numbers — PayPal does).</p>
        <p><strong className="text-white">Usage</strong>: titles you watch, watch-progress, watchlist, profile preferences, device type, IP address (for region & fraud).</p>
        <p><strong className="text-white">Communications</strong>: emails you send our support team and our automated transactional emails to you.</p>
      </Section>

      <Section title="2. How we use it">
        <ul className="list-disc pl-5 space-y-1 text-[#bbb]">
          <li>Run and improve the Service (e.g. recommendations, continue-watching, search).</li>
          <li>Process payments and detect fraud.</li>
          <li>Send essential transactional emails (verification, password reset, billing).</li>
          <li>Send optional marketing emails — you can unsubscribe with one click.</li>
          <li>Comply with legal obligations.</li>
        </ul>
      </Section>

      <Section title="3. Sharing">
        <p>We do <strong className="text-white">not</strong> sell your data. We share limited data only with:</p>
        <ul className="list-disc pl-5 space-y-1 text-[#bbb]">
          <li>Payment processors (PayPal) to process subscriptions.</li>
          <li>Email providers (Resend) to deliver transactional emails.</li>
          <li>Hosting & analytics providers under strict data-processing agreements.</li>
          <li>Law enforcement when legally compelled.</li>
        </ul>
      </Section>

      <Section title="4. Data retention">
        <p>We keep account data for as long as your account is active, plus 12 months for legal/accounting requirements. You can delete your account anytime — billing records may be retained longer where required by law.</p>
      </Section>

      <Section title="5. Your rights (GDPR, CCPA, et al.)">
        <p>You can:</p>
        <ul className="list-disc pl-5 space-y-1 text-[#bbb]">
          <li>Access, export or correct your data.</li>
          <li>Delete your account and request data erasure.</li>
          <li>Object to or restrict certain processing.</li>
          <li>Withdraw consent for marketing communications.</li>
        </ul>
        <p>Email <a className="text-[#E50914]" href="mailto:privacy@djinostream.com">privacy@djinostream.com</a> to exercise any of these rights — we'll respond within 30 days.</p>
      </Section>

      <Section title="6. Children">
        <p>Djino Stream is not directed at children under 13. Kids profiles within an adult account are restricted to family-safe content but still operate under the parent account's terms.</p>
      </Section>

      <Section title="7. Security">
        <p>Passwords are hashed with bcrypt. All traffic is encrypted via TLS. Sensitive operations (billing, password reset) require re-authentication or a verified token. Internal access to user data is logged and audited.</p>
      </Section>

      <Section title="8. International transfers">
        <p>If you're outside the country where our servers are hosted, your data may be transferred and processed there. We use Standard Contractual Clauses where applicable.</p>
      </Section>

      <Section title="9. Changes & contact">
        <p>Material changes to this policy will be emailed to you. For any privacy question: <a className="text-[#E50914]" href="mailto:privacy@djinostream.com">privacy@djinostream.com</a>.</p>
      </Section>
    </PageLayout>
  );
}
